import {
  Button,
  FormField,
  NotificationHub,
} from "@nef/core";
import React, { useState } from "react";
import { useFormContext } from "react-hook-form";

import { ALPHA_NUM_STRICT_LENGTH } from "../constants/regexRepo";

import DeleteIcon from "./DeleteIcon";

const AddIssuerUi = ({ issuerName }: { issuerName: string }) => {

  const { getValues, setValue } = useFormContext();

  const [issuers, setIssuers] = useState<any[]>(getValues("issuers") ?? []);
  const [issuer, setIssuer] = useState(issuerName);
  const [identifier, setIdentifier] = useState("");

  const issuerViewSection = ({ name, id }: any) => {
    return (
      <div className="add-issuer__list-item">
        <div className="add-issuer__info">
          <div className="add-issuer__item">
            <p className="add-issuer__item-title">Issuer Name:</p>
            <p>{name}</p>
          </div>
          <div className="add-issuer__item">
            <p className="add-issuer__item-title">CUSIP/ISIN:</p>
            <p>{id || "-"}</p>
          </div>
        </div>
        <DeleteIcon onClick={(_: any) => {
          const temp = issuers.filter(a => a?.issuerName !== name)
          setIssuers(temp);
          setValue("issuers", temp)
        }}
        />
      </div>
    )
  }
  const issuerHandler = () => {
    if (!issuer) return;

    const existingIssuer = issuers.find((_issuer) => _issuer.issuerName === issuer);
    const doesIssuerAlreadyExist = existingIssuer !== undefined;

    if (doesIssuerAlreadyExist) {
      NotificationHub.send("danger", "Issuer already added!");
      return;
    }

    if (identifier && (!identifier.trim().match(ALPHA_NUM_STRICT_LENGTH(9)) && !identifier.trim().match(ALPHA_NUM_STRICT_LENGTH(12)))) {
      NotificationHub.send("danger", "ISIN should be 12 characters long and CUSIP should be 9 characters long!");
      return;
    }

    const temp = [...issuers, { issuerName: issuer, identifier }];
    setIssuers(temp);
    setValue("issuers", temp);
    setIssuer("");
    setIdentifier("");
  };

  return (
    <div className="add-issuer__container">
      <div className="add-issuer__list">
        <h4>Issuers: </h4>
        {issuers.map((_issuer: any) => {
          return (
            <div className="add-issuer__list-container"
              key={_issuer?.issuerName}
            >
              {issuerViewSection({ name: _issuer?.issuerName, id: _issuer?.identifier })}
            </div>
          );
        })}
        <div className="add-issuer__action">
          <FormField
            className="add-issuer__action-input"
            placeholder="Enter Issuer Name"
            name="issuerName"
            value={issuer}
            size="md"
            onChange={(e: any) => {
              setIssuer(e.value);
            }}
            id="issuerName"
          />
          <FormField
            className="add-issuer__action-input"
            placeholder="Enter CUSIP/ISIN"
            name="issuerIdentifier"
            value={identifier}
            size="md"
            onChange={(e: any) => {
              setIdentifier(e.value);
            }}
            id="issuerIdentifier"
          />
          <Button
            onClick={issuerHandler}
            size="sm"
            color="primary"
            className="add-issuer__action-button"
          >
            Add Issuer
          </Button>
        </div>
      </div>
      <NotificationHub />
    </div >
  );
}
export default AddIssuerUi;